
	import { defineComponent } from "vue";
	export default defineComponent({
		props: {
			routes: Array,
			user: Object,
		}
	});
